import { createContext } from "react";

const values = {
  state: {
    questions: {
      business: {
        equipmentUse: "",
        companyName: "",
        longBussiness: "",
        entityType: "",
        purchase: "",
        bussinessAnual: "",
        monthlyIncome: "",
        industry: "",
        dob: "",
        // address: "",
        homeAddress: "",
        companyAddress: "",
        ssn: "",
        citizenship: "",
        homeowner: false,
        percentage: "",
        businessDescription: "",
        purchaseType: "",
        estimatedRevenue: null,
        // PD-6 Step 4 "Equipment" reveal fields — UI-only for now, no backend
        // contract exists yet for these (see Milestone 2 in the PD-6 plan).
        replacingDescription: "",
        replacingDisposition: "",
      },
      personal: {},
      email: "",
      phone: "+1",
      firstname: "",
      middlename: "",
      lastname: "",
      taxId: "",
      information: "",
      imageFile: null,
      imageName: "",
      fontFamily: "null",
      requestedAmount: null,
      isMarketingLink: false,
      equipmentName: "",
      equipmentCost: "",
      referrerUrl: "",
      referrerEquipmentDescription: "",
      referrerEquipmentCost: null,
      referrerEquipmentImageUrl: "",
      referrerEquipmentMonthlyCost: null,
      referrerEquipmentMiles: "",
      hasSalesRep: null,
      salesRepFirstName: "",
      salesRepLastName: "",
    },
    refreshApplications: false,
    prequalifiedOffers: [],
    informationSlug: "",
    applicationUUID: "",
    refreshApplicationLink: false,
    isLoggedIn: false,
    refreshProfile: false,
    signupResponse: "",
    isPersonalFlow: false,
    isSalesRepFlow: false,
    isPurpleWaveAccount: false,
    user: {
      username: "",
      role: "",
      logo: "",
      themeColor: "",
      profilePicture: null,
      companyCategory: "",
      firstName: "",
      lastName: "",
      email: "",
      phoneNo: "",
      companyName: "",
      address: "",
      isShowOffers: false,
      isShowReports: false,
      isDefault: false,
    },
  },
  dispatch: (action) => {},
};
export const GlobalContext = createContext(values);
GlobalContext.displayName = "GlobalContext";
